import { gql } from '@apollo/client'

const ADD_NEW_REFERRAL_SOURCE = gql`
  mutation ADD_NEW_REFERRAL_SOURCE(
    $generatedID: ID!
    $name: String!
    $order: Int
    $color: String!
    $referralUrl: String
    $referralId: String
    $forceSubtype: Boolean!
    $forPatients: Boolean!
    $forUsers: Boolean!
    $showForPatients: Boolean!
  ) {
    addNewReferralSourceItem(
      generatedID: $generatedID
      name: $name
      order: $order
      color: $color
      referralUrl: $referralUrl
      referralId: $referralId
      forceSubtype: $forceSubtype
      forPatients: $forPatients
      forUsers: $forUsers
      showForPatients: $showForPatients
    ) {
      id
      name
      order
      color
      referralUrl
      referralId
      forceSubtype
      forPatients
      forUsers
      showForPatients
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export default ADD_NEW_REFERRAL_SOURCE
